import { CSSProperties, memo, ReactNode } from 'react'

import styles from './FullWidthWrap.module.scss'

export type FullWidthWrapProps = {
	maxWidth?: number
	children?: ReactNode
	overflow?: string
	style?: CSSProperties
}

export const FullWidthWrap = memo(({ maxWidth = 0, overflow, children, style }: FullWidthWrapProps): JSX.Element => {
	const mergedStyle: CSSProperties = {
		...style,
		maxWidth: maxWidth ? `${maxWidth}px` : style?.maxWidth,
		['--full-width-wrap-overflow' as never]: overflow ?? 'hidden'
	}

	return (
		<div className={styles.fullWidthWrap} style={mergedStyle}>
			{children}
		</div>
	)
})
